var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg097Eye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 5C3.3799 5 1.1399 11.41 1.0499 11.68C0.979787 11.8876 0.979787 12.1124 1.0499 12.32C1.1399 12.59 3.3799 19 11.9999 19C20.1729 19 22.6104 13.2376 22.9606 12.4098L22.9606 12.4097C22.9797 12.3645 22.9926 12.334 22.9999 12.32C23.07 12.1124 23.07 11.8876 22.9999 11.68C22.9926 11.666 22.9797 11.6355 22.9606 11.5903L22.9606 11.5902C22.6104 10.7624 20.1729 5 11.9999 5ZM11.9999 17C5.8099 17 3.6099 13.17 3.0799 12C3.5999 10.86 5.8399 7 11.9999 7C18.1599 7 20.3999 10.84 20.9199 12C20.3999 13.14 18.1599 17 11.9999 17ZM11.9999 8C9.79076 8 7.9999 9.79086 7.9999 12C7.9999 14.2091 9.79076 16 11.9999 16C14.209 16 15.9999 14.2091 15.9999 12C15.9999 9.79086 14.209 8 11.9999 8ZM11.9999 14C10.8953 14 9.9999 13.1046 9.9999 12C9.9999 10.8954 10.8953 10 11.9999 10C13.1045 10 13.9999 10.8954 13.9999 12C13.9999 13.1046 13.1045 14 11.9999 14Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg097Eye);
export default __webpack_public_path__ + "static/media/097-eye.94d6b265dec3bf54a46d82805137d65b.svg";
export { ForwardRef as ReactComponent };